module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n  /**\n   * @name body\n   * @type {!string}\n   */\n\n  /**\n   * @name flavor\n   * @type {!string}\n   */\n\n  /**\n   * @name title\n   * @type {string}\n   */\n%>\n<div class="alert netsim-alert <%= flavor %> fade in">\n  <button type="button" class="netsim-alert-button close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n  <% if (title) { %><strong><%= title %></strong><% } %>\n  <%= body %>\n</div>\n', __filename = "src/netsim/NetSimAlert.html.ejs";
    try {
        var __output = [], __append = __output.push.bind(__output);
        with (locals || {}) {
            __line = 16;
            __append('\n<div class="alert netsim-alert ');
            __line = 17;
            __append(escapeFn(flavor));
            __append(' fade in">\n  <button type="button" class="netsim-alert-button close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n  ');
            __line = 19;
            if (title) {
                __append("<strong>");
                __append(escapeFn(title));
                __append("</strong>");
            }
            __append("\n  ");
            __line = 20;
            __append(escapeFn(body));
            __append("\n</div>\n");
            __line = 22;
        }
        return __output.join("");
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}